import { get } from 'lodash-es';

type ErrorWithBody = {
  body?: unknown;
};

type ErrorWithResponse = {
  response?: {
    body?: unknown;
    status?: unknown;
  };
};

type ErrorWithStatus = {
  status?: unknown;
};

function isRecord(value: unknown): value is Record<string, unknown> {
  return value != null && typeof value === 'object';
}

export function getApiClientErrorBody(error: unknown): unknown {
  if (!isRecord(error)) return undefined;

  if ('body' in error) {
    return (error as ErrorWithBody).body;
  }

  if ('response' in error) {
    const response = (error as ErrorWithResponse).response;
    if (response != null && typeof response === 'object' && 'body' in response) {
      return response.body;
    }
  }

  return undefined;
}

export function getApiClientErrorStatus(error: unknown): number | undefined {
  if (!isRecord(error)) return undefined;

  const status = (error as ErrorWithStatus).status;
  if (typeof status === 'number') return status;

  const responseStatus = (error as ErrorWithResponse).response?.status;
  return typeof responseStatus === 'number' ? responseStatus : undefined;
}

export function isApiClientError(error: unknown): boolean {
  return getApiClientErrorStatus(error) !== undefined;
}

export function getApiClientErrorDetail(body: unknown): string | undefined {
  const message = get(body, 'message') ?? get(body, 'errors[0].detail');
  return message != null ? String(message) : undefined;
}

export function formatApiClientErrorMessage(body: unknown, status: number): string {
  return getApiClientErrorDetail(body) ?? `An unexpected error occured with HTTP code ${status}`;
}

export function getApiClientErrorMessageFromError(error: unknown): string | undefined {
  const status = getApiClientErrorStatus(error);
  if (status === undefined) return undefined;
  return formatApiClientErrorMessage(getApiClientErrorBody(error), status);
}
